import { render, staticRenderFns } from "./OrderFeedback.vue?vue&type=template&id=692980c2&scoped=true"
import script from "./OrderFeedback.vue?vue&type=script&lang=js"
export * from "./OrderFeedback.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OrderFeedback.vue?vue&type=style&index=1&id=692980c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692980c2",
  null
  
)

export default component.exports